function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
}
module.exports = _isObject;


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/ramda/src/internal/_isObject.js
// module id = 748
// module chunks = 168707334958949